import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import FHIR, { client } from "fhirclient";
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();

    changeMessage(message: any) {
        this.messageSource.next(message);
    }

    url: string = "https://mpis.ocr.mhnexus.com";
    // url: string = "http://localhost:8000";
    constructor(private http: HttpClient) { }

    verifyToken(temporaryToken: string) {
        //   const headers = { Authorization: `Bearer ${accessToken}` };
        return this.http.get(this.url + '/api/v1/security/link-verify?token=' + temporaryToken);
    }

    refreshToken(payload: any) {
        return this.http.post(this.url + '/api/v1/security/refresh', payload);
    }

}
